import { Fragment } from 'react';
import { useEsigningRecipients } from 'app/domains/esigning/hooks/useEsigningRecipients';
import { EmptySigningParties } from './EmptyRecipients';
import { Signers } from './Signers';
import { Viewers } from './Viewers';
export function Recipients() {
    const { allRecipients } = useEsigningRecipients();
    if (allRecipients.length === 0) {
        return <EmptySigningParties />;
    }
    return (<Fragment>
      <Signers />
      <Viewers />
    </Fragment>);
}
